import React, { useContext, useState } from "react";
import { isEmpty, isNull } from "lodash";
import FiltersContext from "../../restaurantsMap/FiltersContext";
import PropTypes from "prop-types";

const FiltersForm = ({ dataForm }) => {
  const { availableOptions, selectedRestaurants } = useContext(FiltersContext);
  const [filtersConfiguration, setFiltersConfiguration] = useState(null);

  const formElements = ["brands", "countries"];

  const translations = {
    divisions: Drupal.t("Select division") + ':*',
    countries: Drupal.t("Select country") + ':',
    brands: Drupal.t("Select brand") + ':',
    localizations: Drupal.t("Localizations"),
    no_restaurants: Drupal.t("No restaurant found")
  }

  const handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (value !== "") {
      if (name === "divisions") {
        setFiltersConfiguration(() => {
          dataForm({ [name]: value });
          return { [name]: value };
        });
      } else {
        setFiltersConfiguration(prevState => {
          dataForm({ ...prevState, [name]: value });
          return { ...prevState, [name]: value };
        });
      }
    } else {
      let state = filtersConfiguration;
      delete state[name];
      if (isEmpty(state)) {
        dataForm(null);
        setFiltersConfiguration(null);
      } else {
        dataForm(state);
        setFiltersConfiguration(state);
      }
    }
  };
  function noRestaurants(selectedRestaurants) {
      if (!isNull(selectedRestaurants) && selectedRestaurants == 0) {
          return (
              <div className="col-12">
                <h4>{translations['no_restaurants']}</h4>
              </div>
          );
      } else {
          return null;
      }
  };

  return (
    <div>
      <form>
        <div className="form-row">
          <div className="col-12">
            <h3>{translations['localizations']}</h3>
          </div>
        </div>
        <div className="form-row no-restaurants">
          { noRestaurants(selectedRestaurants) }
        </div>
          {formElements.map((field, key) => {
            return (
                <div className="form-row" key={key}>
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor={`restaurantsMapBrands-${key}`}>
                        {translations[field]}
                      </label>
                      <select
                        name={field}
                        onChange={handleInputChange}
                        className="form-control"
                        id={`restaurantsMapBrands-${key}`}
                        defaultValue=""
                      >
                        <option value="">{Drupal.t("- Select -")}</option>
                        {availableOptions[field].map((item, key) => {
                          return (
                            <option key={key} value={item}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
            );
          })}
      </form>
    </div>
  );
};

FiltersForm.propTypes = {
  dataForm: PropTypes.func.isRequired
};

export default FiltersForm;
